<div class="p-3 billing-container">
    <tabs
        [tabs]="tabs"
        [tabIndex]="tabIndex"
        (tabChange)="tabChange($event)"
    ></tabs>
  <div class="pt-2 billing-container-content overflow-y-scroll">
    <ng-container *ngIf="billings.length > 0; else noData">
      <ng-container *ngFor="let billing of billings; let i = index">
        <div [ngClass]="{'even': i % 2 === 0, 'odd': i % 2 !== 0}" class="billing p-2">
          <div class="flex">
            <h3 (click)="routeToBillingPage(billing.patientId)" class="mb-1">{{billing.name}}</h3> <p> ({{billing.discipline}} - {{billing.mode}})</p> <p> {{ billing.date}} </p>
          </div>
          <div class="flex details py-2 align-items-baseline">
            <div [ngClass]="{'error': !billing.isBilled, 'warning': billing.isBilled && billing.isBilledError, 'yes': billing.isBilled && !billing.isBilledError}" class="py-1 px-1 flex h-8">
              <img *ngIf="billing.isBilledError && billing.isBilled" class="pr-1" src="/assets/home/warning-solid.svg" />
              <img *ngIf="billing.isBilled && !billing.isBilledError" class="pr-1" src="/assets/home/tick-round.svg" />
              {{billing.isBilled ? appConstant.billed : appConstant.notBilled}}
            </div>
            <div class="py-1 px-1 flex h-8" [ngClass]="{'error': billing.noteStatus === NotesStatusOptions.Incomplete , 'warning': billing.noteStatus === NotesStatusOptions.Partially, 'yes': billing.noteStatus === NotesStatusOptions.Complete}">
              <img *ngIf="billing.noteStatus === NotesStatusOptions.Complete" class="pr-1" src="/assets/home/tick-round.svg" />
              <img *ngIf="billing.noteStatus === NotesStatusOptions.Partially" class="pr-1" src="/assets/home/warning-solid.svg" />
              {{appConstant.note}}
            </div>
            <ng-container *ngIf="billing.isBilledError">
              <span *ngIf="billing.isAgenda; else noAgenda">{{appConstant.agenda}}: {{billing.agendaMins}}</span>
            </ng-container>
            <span *ngIf="billing.isBilledError && billing.isBilled">{{appConstant.billed}}: {{billing.billedMins}}</span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<ng-template #noAgenda>
  <span>{{appConstant.noAgenda}}</span>
</ng-template>
<ng-template #noData>
  <span class="flex justify-center pt-20 text-center">
    {{ appConstant.noDataFound }}
  </span>
  </ng-template>